import classnames from 'classnames/bind'

// Libs

// Components
import Icon from '@/assets/icons'

// Constants

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)
type NavigationType = {
  className?: string
  iconClassName?: string
  direction: 'left' | 'right'
  onClick: () => void
}
const Navigation = (props: NavigationType) => {
  const { className, iconClassName, direction, onClick } = props

  const isLeft = direction === 'left'
  const isRight = direction === 'right'

  return (
    <button className={cx('navigation-button', { left: isLeft, right: isRight }, className)} type='button' onClick={onClick}>
      <div className={cx('navigation-button-icon', { left: isLeft, right: isRight }, iconClassName)}>
        <Icon.ArrowLeft />
      </div>
    </button>
  )
}

export default Navigation
